import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const IconList = ({ children }) => (
  <ul className="fa-ul">
    {children}
  </ul>
);

export const IconListItem = ({ children, icon, iconClassName }) => (
  <li>
    <span className="fa-li">
      <FontAwesomeIcon icon={icon} className={iconClassName} fixedWidth />
    </span>
    {children}
  </li>
);
